<template>
  <section>
    <h2>Вы заказали:</h2>
    <v-simple-table v-if="this.$store.state.Window1.widthWindow1 && this.$store.state.Window1.heightWindow1">
      <thead>
        <tr>
          <th class="text-left">№</th>
          <th class="text-left">Комната</th>
          <th class="text-left">Размер стены, мм</th>
          <th class="text-left">Тип окна</th>
          <th class="text-left">Комплект штор</th>
          <th class="text-left">Светозащита</th>
          <th class="text-left">Карниз</th>
          <th class="text-left">Доп. услуги</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>{{ this.$store.state.Window1.nameWindow1 }}</td>
          <td>{{ this.$store.state.Window1.widthWindow1 }}*{{ this.$store.state.Window1.heightWindow1 }}</td>
          <td>{{ this.$store.state.Window1.windowTypeSelected1 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain1 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles1Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected1 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains">{{ this.$store.state.AddOptions.mountingCurtains }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains">{{ this.$store.state.AddOptions.hangingCurtains }}</li>
              <li v-if="this.$store.state.AddOptions.blackout">{{ this.$store.state.AddOptions.blackout }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll">{{ this.$store.state.AddOptions.mountingRoll }}</li>
            </ul>
          </td>
        </tr>
        <tr v-if="this.$store.state.Window2.widthWindow2 && this.$store.state.Window2.heightWindow2">
          <td>2</td>
          <td>{{ this.$store.state.Window2.nameWindow2 }}</td>
          <td>{{ this.$store.state.Window2.widthWindow2 }}*{{ this.$store.state.Window2.heightWindow2 }}</td>
          <td>{{ this.$store.state.Window2.windowTypeSelected2 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain2 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles2Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected2 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains2">{{ this.$store.state.AddOptions.mountingCurtains2 }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains2">{{ this.$store.state.AddOptions.hangingCurtains2 }}</li>
              <li v-if="this.$store.state.AddOptions.blackout2">{{ this.$store.state.AddOptions.blackout2 }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll2">{{ this.$store.state.AddOptions.mountingRoll2 }}</li>
            </ul>
          </td>
        </tr>
        <tr v-if="this.$store.state.Window3.widthWindow3 && this.$store.state.Window3.heightWindow3">
          <td>3</td>
          <td>{{ this.$store.state.Window3.nameWindow3 }}</td>
          <td>{{ this.$store.state.Window3.widthWindow3 }}*{{ this.$store.state.Window3.heightWindow3 }}</td>
          <td>{{ this.$store.state.Window3.windowTypeSelected3 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain3 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles3Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected3 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains3">{{ this.$store.state.AddOptions.mountingCurtains3 }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains3">{{ this.$store.state.AddOptions.hangingCurtains3 }}</li>
              <li v-if="this.$store.state.AddOptions.blackout3">{{ this.$store.state.AddOptions.blackout3 }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll3">{{ this.$store.state.AddOptions.mountingRoll3 }}</li>
            </ul>
          </td>
        </tr>
        <tr v-if="this.$store.state.Window4.widthWindow4 && this.$store.state.Window4.heightWindow4">
          <td>4</td>
          <td>{{ this.$store.state.Window4.nameWindow4 }}</td>
          <td>{{ this.$store.state.Window4.widthWindow4 }}*{{ this.$store.state.Window4.heightWindow4 }}</td>
          <td>{{ this.$store.state.Window4.windowTypeSelected4 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain4 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles4Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected4 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains4">{{ this.$store.state.AddOptions.mountingCurtains4 }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains4">{{ this.$store.state.AddOptions.hangingCurtains4 }}</li>
              <li v-if="this.$store.state.AddOptions.blackout4">{{ this.$store.state.AddOptions.blackout4 }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll4">{{ this.$store.state.AddOptions.mountingRoll4 }}</li>
            </ul>
          </td>
        </tr>
        <tr v-if="this.$store.state.Window5.widthWindow5 && this.$store.state.Window5.heightWindow5">
          <td>5</td>
          <td>{{ this.$store.state.Window5.nameWindow5 }}</td>
          <td>{{ this.$store.state.Window5.widthWindow5 }}*{{ this.$store.state.Window5.heightWindow5 }}</td>
          <td>{{ this.$store.state.Window5.windowTypeSelected5 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain5 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles5Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected5 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains5">{{ this.$store.state.AddOptions.mountingCurtains5 }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains5">{{ this.$store.state.AddOptions.hangingCurtains5 }}</li>
              <li v-if="this.$store.state.AddOptions.blackout5">{{ this.$store.state.AddOptions.blackout5 }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll5">{{ this.$store.state.AddOptions.mountingRoll5 }}</li>
            </ul>
          </td>
        </tr>
        <tr v-if="this.$store.state.Window6.widthWindow6 && this.$store.state.Window6.heightWindow6">
          <td>6</td>
          <td>{{ this.$store.state.Window6.nameWindow6 }}</td>
          <td>{{ this.$store.state.Window6.widthWindow6 }}*{{ this.$store.state.Window6.heightWindow6 }}</td>
          <td>{{ this.$store.state.Window6.windowTypeSelected6 }}</td>
          <td>{{ this.$store.state.Curtains.modelCurtain6 }}</td>
          <td>{{ this.$store.state.Tulles.kitTulles6Choosen }}</td>
          <td>{{ this.$store.state.Karniz.karTypeSelected6 }}</td>
          <td>
            <ul>
              <li v-if="this.$store.state.AddOptions.mountingCurtains6">{{ this.$store.state.AddOptions.mountingCurtains6 }}</li>
              <li v-if="this.$store.state.AddOptions.hangingCurtains6">{{ this.$store.state.AddOptions.hangingCurtains6 }}</li>
              <li v-if="this.$store.state.AddOptions.blackout6">{{ this.$store.state.AddOptions.blackout6 }}</li>
              <li v-if="this.$store.state.AddOptions.mountingRoll6">{{ this.$store.state.AddOptions.mountingRoll6 }}</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-divider class="pb-5"/>
    <h3 align="right">Итого: {{ this.$store.state.Final.finalCost }} руб.</h3>
    <h2 v-if="this.$store.state.Window1.widthWindow1 && this.$store.state.Window1.heightWindow1">Заполните форму</h2>
    <v-row class="pt-5" v-if="this.$store.state.Window1.widthWindow1 && this.$store.state.Window1.heightWindow1">
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="name"
          required
          outlined
          label="Имя"
          prepend-inner-icon="person"
        />
        <v-text-field
          v-model="secondName"
          outlined
          label="Фамилия"
          prepend-inner-icon="person"
        />
        <v-text-field
          v-model="phone"
          required
          outlined
          label="Телефон"
          prepend-inner-icon="phone"
        />
        <v-text-field
          v-model="address"
          required
          outlined
          label="Адрес"
          prepend-inner-icon="place"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-textarea
          v-model="comment"
          height="313"
          label="Комментарий к заказу"
          outlined
          counter
          full-width
        ></v-textarea>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'Order',
  data () {
    return {
    }
  },
  computed: {
    name: {
      get () {
        return this.$store.state.Final.name
      },
      set (value) {
        this.$store.commit('updateName', value)
      }
    },
    secondName: {
      get () {
        return this.$store.state.Final.secondName
      },
      set (value) {
        this.$store.commit('updateSecondName', value)
      }
    },
    phone: {
      get () {
        return this.$store.state.Final.phone
      },
      set (value) {
        this.$store.commit('updatePhone', value)
      }
    },
    comment: {
      get () {
        return this.$store.state.Final.comment
      },
      set (value) {
        this.$store.commit('updateComment', value)
      }
    },
    address: {
      get () {
        return this.$store.state.Final.address
      },
      set (value) {
        this.$store.commit('updateAddress', value)
      }
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
